import { AppRouteProps } from "@bsm/component";
import ProjectTimeOffCreateLeavingContainer from "./container/ProjectTimeOffCreateLeavingContainer";

export const ProjectTimeOffCreateLeavingRoutes: Array<AppRouteProps> = [
    {
        path: "create",
        title: "BSMRH.Project.TimeOff.Create.Leaving.Label",
        element: <ProjectTimeOffCreateLeavingContainer />,
    },
    {
        path: ":id/edit",
        title: "BSMRH.Project.TimeOff.Create.Leaving.Label",
        element: <ProjectTimeOffCreateLeavingContainer />,
    },
];
